import { render, staticRenderFns } from "./NewPc.vue?vue&type=template&id=660f30b0&scoped=true&"
import script from "./NewPc.vue?vue&type=script&lang=js&"
export * from "./NewPc.vue?vue&type=script&lang=js&"
import style0 from "./NewPc.vue?vue&type=style&index=0&id=660f30b0&prod&lang=css&"
import style1 from "./NewPc.vue?vue&type=style&index=1&id=660f30b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660f30b0",
  null
  
)

export default component.exports